<template>
  <ElSelect
    :value="value"
    filterable
    placeholder="Select Company Size"
    autocomplete="nope"
    @change="handler"
  >
    <ElOption
      v-for="(label, code) in organizationSizes"
      :key="code"
      :label="label"
      :value="code"
    />
  </ElSelect>
</template>

<script>
import organizationSizes from '@/config/datalists/organizationSizes.js'

export default {
  name: 'OrganizationSize',
  props: {
    value: {
      type: String,
      default: ''
    },
    vuelidate: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    organizationSizes() {
      return organizationSizes
    }
  },
  methods: {
    handler(newVal) {
      this.$emit('update:value', newVal)
      this.vuelidate()
    }
  }
}
</script>
